const expressRechargeStatuses = {
  SHOW: "show",
  CONFIRM: "confirm",
  SUCCESS: "success",
  FAILURE: "failure",
};

export default expressRechargeStatuses;
